import { connect } from 'react-redux';
import { IState } from '../../store';
import { closeSuccess } from '../../store/deal-rent';
import { DealRentSuccessModal } from './DealRentSuccessModal';

export function mapStateToProps(state: IState) {
  return {
    isOpen: state.dealRent.isSuccessModal,
  };
}

export const DealRentSuccessModalContainer = connect(mapStateToProps, { closeModal: closeSuccess })(
  DealRentSuccessModal,
);
